interface AnonToken {
  access_token_v2: string;
  id_token: string;
  token_type: 'Bearer';
}

const ANON_SERVER_PATH = '/token/anon';

export interface ErrorRes {
  status: 'ERROR';
  value: {
    message: string;
  };
}

export interface SuccessRes {
  status: 'SUCCESS';
  value: {
    token: string;
  };
}

type AnonTokenFromServer = () => Promise<SuccessRes | ErrorRes>;

const buildFetchInit = (): RequestInit => ({
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: process.env.NODE_ENV === 'development' ? 'include' : 'same-origin',
});

const getTokenFromAnonServer: AnonTokenFromServer = async () => {
  try {
    const result = await fetch(
      `${process.env.MONOLITH_HOST_URL}${ANON_SERVER_PATH}`,
      buildFetchInit()
    );
    const data = await (result.json() as Promise<AnonToken>);

    const accessToken = data?.access_token_v2;

    if (accessToken) {
      return {
        status: 'SUCCESS',
        value: {
          token: accessToken,
        },
      };
    }

    return {
      status: 'ERROR',
      value: {
        message: 'No token recieved from Anon Server',
      },
    };
  } catch (err) {
    return {
      status: 'ERROR',
      value: {
        message: err.message,
      },
    };
  }
};

export default getTokenFromAnonServer;
